import { render, staticRenderFns } from "./Sensitive.vue?vue&type=template&id=cfdf9ff2&scoped=true"
import script from "./Sensitive.vue?vue&type=script&lang=js"
export * from "./Sensitive.vue?vue&type=script&lang=js"
import style0 from "./Sensitive.vue?vue&type=style&index=0&id=cfdf9ff2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cfdf9ff2",
  null
  
)

export default component.exports